<template>
  <v-container>
    <div class="footer-border" />
    <h4 class="header">
      VIEWING AS
    </h4>
    <p
      class="data"
      data-cy="viewing-as-user-name"
    >
      <b>{{ userName }}</b>{{ roleType }}
    </p>
    <p
      v-if="companyName"
      data-cy="viewing-as-company-name"
      class="data"
    >
      {{ companyName }}
    </p>
    <p
      v-if="activeOrg != null && (viewAsCompany!= null || !snAdmin)"
      class="data"
      data-cy="sr-active-org"
    >
      {{ activeOrg.value }}
    </p>
    <p
      v-if="viewAsCompany != null|| !snAdmin"
      class="data">
      {{ isStaging ? 'Staging' : 'Production' }}
    </p>
  </v-container>
</template>

<script>

import { mapGetters } from 'vuex'
import _ from 'lodash'
import { companyOrgs } from '../graphql/signing_room_queries.gql'

export default {
  name: 'ViewingAs',
  data () {
    return {
      orgOptions: [],
      activeOrg: null
    }
  },
  computed: {
    ...mapGetters(['user', 'isStaging', 'orgId', 'viewAsCompany']),
    userName () {
      if (this.user) {
        return this.user.firstName + ' ' + this.user.lastName
      }
      return ''
    },
    roleType () {
      if (this.user.accountType) {
        const roleDisplay = _.capitalize(this.user.accountType.replaceAll('_', ' '))
        return ` - ${roleDisplay}`
      }
      return ''
    },
    companyName () {
      if (!this.user) {
        return null
      } else if (this.user.isSnAdmin && this.viewAsCompany) {
        return this.viewAsCompany.name
      } else if (this.user.company) {
        return this.user.company.name
      }

      return null
    },
    snAdmin () {
      return this.user != null && this.user.accountType === 'admin'
    },
    timeZone () {
      if (!this.user) {
        return null
      } else if (this.user.timezone) {
        return this.user.timezone
      }
      return null
    }
  },
  watch: {
    orgId () {
      this.getOrgs()
    },
    viewAsCompany () {
      this.getOrgs()
    }
  },
  created () {
    document.addEventListener('click', this.clickAway)
    this.getOrgs()
  },
  methods: {
    getOrgs () {
      if (this.snAdmin && (!this.viewAsCompany || !this.viewAsCompany.guid)) {
        return null
      } else {
        this.$apollo.query({
          query: companyOrgs,
          variables: {
            companyGuid: this.viewAsCompany == null ? null : this.viewAsCompany.guid
          }
        }).then(({ data }) => {
          if (data.companyOrgs) {
            const orgs = data.companyOrgs

            this.orgOptions = orgs.map(org => {
              return { guid: org.guid, value: org.name, subtext: '', action: 'switch_org' }
            })
            this.activeOrg = this.orgOptions.find(opt => opt.guid === this.orgId)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';
.container {
  padding: 16px;
}

.footer-border {
  margin: -16px -16px 16px -16px;
  border-top: 1px solid #E5E5E5 !important;
}

.header {
  color: #BFBFBF;
}

.data {
  margin: 0 !important;
}

</style>
